export const environment = {
	production: true,
	urlApi: 'https://api.movsa.net/api/'
};
